module.exports = __webpack_public_path__ + "img/bg4.b1fbe7ee.jpg";